import { render, staticRenderFns } from "./programa-registro-f1.vue?vue&type=template&id=35d75a38&"
import script from "./programa-registro-f1.component.ts?vue&type=script&lang=ts&"
export * from "./programa-registro-f1.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports